import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import DeleteIcon from 'react-icons/lib/md/close'
import FaFileTextO from 'react-icons/lib/fa/file-text-o'
import FaEye from 'react-icons/lib/fa/eye'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'

@withMutation(gql`
  mutation deleteAttach($documentId: ID, $attachedDoc: DocumentAttachedInput) {
    deleteAttach(documentId: $documentId, attachedDoc: $attachedDoc) {
      success
    }
  }
`)
@withMessage
export default class AnnexedsTable extends React.Component {
  static propTypes = {
    document: PropTypes.object,
    files: PropTypes.object,
    deleteAttach: PropTypes.func,
    showMessage: PropTypes.func
  }

  async delete(file) {
    console.log(file)
    this.setState({ loading: true })
    try {
      await this.props.deleteAttach(
        { documentId: this.props.document._id, attachedDoc: file },
        {
          refetchQueries: ['getDocument']
        }
      )
      this.props.showMessage('Success')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, { level: 'error' })
    }
    this.setState({ loading: false })
  }

  renderTable() {
    const table = this.props.files || []

    return table.map(file => {
      if(!file.attach)
        return ""
      return (
        <div className={styles.show} key={file.name}>
          <div className={styles.container}>
            <div className="row">
              <div className="col-xs-1 col-sm-1">
                <FaFileTextO size={20} />
              </div>
              <div className="col-xs-9 col-sm-9">
                <div className={styles.document}>{file.name}</div>
              </div>
              <div className="col-xs-1 col-sm-1">
                <div className={styles.view}>
                  <a href={file.attach.url} target="blank">
                    <Tooltip content="Ver o descargar el archivo adjunto">
                      <FaEye size={20} color={'#525f7f'} />
                    </Tooltip>
                  </a>
                </div>
              </div>
              { !this.props.document.rejected && this.props.document.documentOwner && !this.props.document.filledBy ? (
                  <div className="col-xs-1 col-sm-1">
                    <div className={styles.delete}>
                      <DeleteIcon size={20} onClick={() => this.delete(file)} />
                    </div>
                  </div>
                ) : null}
            </div>
          </div>
          <br />
        </div>
      )
    })
  }

  render() {
    return <div>{this.renderTable()}</div>
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/AnnexedDocuments/AnnexedsTable/index.js